/**
 * Development-only logging utilities
 * These functions only log in development mode and are silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Log debug information (only in development)
 * @param {...any} args - Arguments to log
 */
export function logDebug(...args) {
  if (isDevelopment) {
    console.log(...args);
  }
}

/**
 * Log warning (only in development)
 * @param {...any} args - Arguments to log
 */
export function logWarn(...args) {
  if (isDevelopment) {
    console.warn(...args);
  }
}

/**
 * Log error (always logs, but with additional context in development)
 * @param {...any} args - Arguments to log
 */
export function logError(...args) {
  console.error(...args);
}

/**
 * Log info (only in development)
 * @param {...any} args - Arguments to log
 */
export function logInfo(...args) {
  if (isDevelopment) {
    console.info(...args);
  }
}

/**
 * Group logs together (only in development)
 * @param {string} label - Group label
 * @param {Function} callback - Function containing logs to group
 */
export function logGroup(label, callback) {
  if (isDevelopment) {
    console.group(label);
    callback();
    console.groupEnd();
  }
}
